module.exports = __webpack_public_path__ + "static/img/order-mobile-2.f2342a8c.png";